// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/exclamation-circle.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'exclamation-circle',
  version: 'outline',
  paths: [
    {
      d: 'M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z',
    },
  ],
}
